<script>
  import { createEventDispatcher } from "svelte";
  export let buttonValue;

  const dispatch = createEventDispatcher()

  const handleClick = () => { 
    dispatch('handleClick', buttonValue.action)
  }
</script>

<button on:click = {handleClick}>
  { buttonValue.label }
</button>

<style>
  button {
    border: 1px solid black;
    border-radius: 20px;
    height: 1.7em;
    padding: 0 2%;
    cursor: pointer;
    transition: all 50ms;
  }
</style>